import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Live = () => {
  const { t } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 via-teal-800 to-blue-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://i.imgur.com/mrt24S8.jpeg?auto=compress&cs=tinysrgb&w=1600"
            alt="ASC Live Event"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            {t('live.event.title')}
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto mb-8">
            {t('live.event.subtitle')}
          </p>
          <div className="w-full max-w-5xl mx-auto">
            <iframe
              src="https://www.liveheats.com/Asc"
              title="Liveheats ASC"
              className="w-full h-[600px] rounded-lg border-0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Live;